import axios from 'axios';
import { apiBaseUrl } from './apiBaseUrl';

// Sign-in-free pages opened from AI assistants. The token lives in the URL
// fragment (never sent to servers or logged) and travels in a header.
export function readLinkToken(hash = '') {
  const token = String(hash).replace(/^#/, '');
  return /^[A-Za-z0-9_-]{43}$/.test(token) ? token : null;
}

export function createAgentLinkClient(token, baseURL = apiBaseUrl) {
  return axios.create({ baseURL, headers: { 'X-Agent-Link': token } });
}

// Same request/response shapes as the photographer upload endpoints.
export function agentUploadApi(client) {
  return {
    client,
    addPath: '/agent-links/upload/pictures',
    completePath: pictureId => `/agent-links/upload/pictures/${encodeURIComponent(pictureId)}/complete`,
    removePicture: null,
  };
}

export function linkErrorMessage(error) {
  const response = error?.response;
  if (!response) return '无法连接服务器，请检查网络后重试。';
  const code = response.data?.code;
  if (['AGENT_LINK_INVALID', 'AGENT_LINK_EXPIRED', 'AGENT_LINK_REVOKED'].includes(code)) {
    return '链接已失效（超过 24 小时或已被撤销），请回到对话让助手重新生成。';
  }
  if (code === 'SUBSCRIPTION_EXPIRED') return '会员已到期，续费后才能继续上传。';
  if (code === 'USER_BANNED') return '账号已停用，无法使用该链接。';
  if (code === 'ORDER_NOT_FOUND') return '订单已不存在。';
  return response.data?.message || response.data?.error || `请求失败（HTTP ${response.status}），请稍后重试。`;
}
